import React from 'react';

const Settings = (props) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 10.5309V20.6559" stroke="#3F3C43" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 4.15591V6.78091" stroke="#3F3C43" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M12 10.5309C13.0355 10.5309 13.875 9.69145 13.875 8.65591C13.875 7.62038 13.0355 6.78091 12 6.78091C10.9645 6.78091 10.125 7.62038 10.125 8.65591C10.125 9.69145 10.9645 10.5309 12 10.5309Z"
      stroke="#3F3C43"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path d="M18.75 18.0309V20.6559" stroke="#3F3C43" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.75 4.15591V14.2809" stroke="#3F3C43" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M18.75 18.0309C19.7855 18.0309 20.625 17.1914 20.625 16.1559C20.625 15.1204 19.7855 14.2809 18.75 14.2809C17.7145 14.2809 16.875 15.1204 16.875 16.1559C16.875 17.1914 17.7145 18.0309 18.75 18.0309Z"
      stroke="#3F3C43"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path d="M5.25 15.0309V20.6559" stroke="#3F3C43" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.25 4.15591V11.2809" stroke="#3F3C43" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5.25 15.0309C6.28553 15.0309 7.125 14.1914 7.125 13.1559C7.125 12.1204 6.28553 11.2809 5.25 11.2809C4.21447 11.2809 3.375 12.1204 3.375 13.1559C3.375 14.1914 4.21447 15.0309 5.25 15.0309Z"
      stroke="#3F3C43"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default Settings;
